export default __webpack_public_path__ + "static/media/icon-sms-service-round.cb86338b.svg";